import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TemplateDetailsPage, { getDefaultData } from "components/pages/TemplateDetailsPage";
import { getDefaultData as getWorkflowData } from "components/workflows/NonNachaFileImportWorkflow";
import Classes, { ACHFromAccount, ACHTemplate, ACHToParticipant, Company, CompanyAccount, NonNachaParticipants, Participant } from "model";

/**
 * @name CaptureAmountAdded
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureAmountAdded(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    let nextParticipantId = Participant.nextID();
    const nonNachaParticipants = NonNachaParticipants.initAll().reduce((acc, item) => {
        const added = Participant.init({
            ...item.record,
            id: nextParticipantId,
        });

        nextParticipantId = parseFloat(nextParticipantId) + 1
        acc.push(added);

        return acc;
    }, []);

    let nextACHToParticipantId = ACHToParticipant.nextID();
    const achToParticipants = nonNachaParticipants.reduce((acc, item) => {
        const added = ACHToParticipant.init({
            id: nextACHToParticipantId,
            participant: Participant.init({ ...item.record, isSelected: "true" }),
            notify: "No",
            addenda: "0",
            numberOfDistributions: "1",
            amount: "1.00"
        });

        nextACHToParticipantId = parseFloat(nextACHToParticipantId) + 1
        acc.push(added);

        return acc;
    }, []);

    const selectedTemplate = ACHTemplate.init({
        id: ACHTemplate.nextID(),
        transactionType: "payment",
        secCode: "PPD Credit - Consumer Credit",
        name: "SamplePPD",
        companyDiscretionaryData: "",
        companyEntryDescription: "Payroll",
        creditAmount: "0.00",
        debitAmount: "0.00",
        achToParticipants: [],
        achFromAccount: [],
        company: Company.initByID(0),
        companyAccount: CompanyAccount.initByID(0),
        numberOfAccounts: "0"
    });

    const addedAccount = ACHFromAccount.init({ account: "6", id: ACHFromAccount.nextID(), amount: "3.00" });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template" ], selectedTemplate)
    .update([ "achToParticipants", "participants" ], achToParticipants)
    .update([ "achFromAccounts", "accounts" ], [ addedAccount ])
    .submit();

    const ui = BCMSStateManagerCRUD.init(getWorkflowData().ui)
    //.update([ "offsetAccountSelectIsActive" ], { isActive: true })
    .submit();

    return <TemplateDetailsPage data={ data } ui={ ui } />;
}